<div class="chart">
    <apx-chart
        [series]="chartOptions.series!"
        [chart]="chartOptions.chart!"
        [xaxis]="chartOptions.xaxis!"
        [yaxis]="chartOptions.yaxis!"
        [colors]="chartOptions.colors!"
        [grid]="chartOptions.grid!"
        [stroke]="chartOptions.stroke!"
        [legend]="chartOptions.legend!"
        [tooltip]="chartOptions.tooltip!"
        [dataLabels]="chartOptions.dataLabels!"
    ></apx-chart>
</div>